import AfEventApi from '../afevent';

const FreecshotPlusEventApi = {
  /**
   * 이벤트 상태 조회 api
   * @return {Promise<void>}
   */
  getEventStatus: async (params) => {
    try {
      const response = await AfEventApi.post(
        `/api/freecshot_plus_event_api.php`,
        params,
      );
      return response;
    } catch (e) {
      return e.response;
    }
  },
};

export default FreecshotPlusEventApi;
